<template>
  <label
    :class="`container ${
      checked ? 'container--active' : ''
    } container-${color}`"
  >
    <slot></slot>
    <input
      type="radio"
      :checked="checked"
      :name="group"
      :disabled="disabled"
      @click="$emit('update:modelValue', name)"
    />
    <span class="check-mark"><span class="inner-check-mark"></span></span>
  </label>
</template>

<script lang="ts">
export default {
  name: 'HMRadio',
  props: {
    modelValue: {
      default: true,
      required: true,
    },
    group: {
      type: String,
      default: 'radio',
      required: true,
    },
    name: {
      type: [String, Number, Boolean],
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
    },
  },
  computed: {
    checked(): boolean {
      return this.modelValue === this.name;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/components-variables.scss';
.container {
  display: flex;
  align-items: center;
  position: relative;
  height: auto;
  padding-left: 33px;
  margin: 0;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  transition: color 0.1s ease-in;
  &--active {
    color: $charcoal;
  }
}

.container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.check-mark {
  position: absolute;
  top: 0;
  left: 0;
  height: 24px;
  width: 24px;
  border-radius: 500%;
  border: 2px solid $medium-gray;
  transition: all 0.1s ease-in;
  box-sizing: border-box;
}

.inner-check-mark {
  position: absolute;
  background-color: white;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  top: 4px;
  left: 4px;
}

.container:hover input ~ .check-mark {
  background-color: $white;
}
.container input:checked ~ .check-mark {
  background-color: $white;
  border: 2px solid var(--brand-color, $coral);
  .inner-check-mark {
    background-color: var(--brand-color, $coral);
  }
}

.container-lwi input:checked ~ .check-mark,
.container-cbf input:checked ~ .check-mark {
  border: 2px solid $lwi-color;
  .inner-check-mark {
    background-color: $lwi-color;
  }
}

.container-mm input:checked ~ .check-mark {
  border: 2px solid $mm-color;
  .inner-check-mark {
    background-color: $mm-color;
  }
}

.container-ic input:checked ~ .check-mark {
  border: 2px solid $mustard;
  .inner-check-mark {
    background-color: $mustard;
  }
}

.container input:disabled ~ .check-mark {
  opacity: 0.5;
}
</style>
